import React from 'react'
import { Link } from 'react-router-dom'
import styles from './MobileMenu.module.css'
import { motion } from 'framer-motion'

interface NavItem {
  id: string
  label: string
  Icon: React.ComponentType<{ className?: string }>
}

interface MobileMenuProps {
  open: boolean
  onClose: () => void
  onNavClick: (id: string) => void
  navItems: NavItem[]
  navItemCategories: NavItem[]
}

export const MobileMenu: React.FC<MobileMenuProps> = ({
  open,
  onClose,
  onNavClick,
  navItems,
  navItemCategories,
}) => {
  if (!open) return null

  // Функція для навігації з прокручуванням
  const handleNavClick = (id: string) => {
    onNavClick(id)
    // Додаткове прокручування вгору для мобільного меню
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }, 150)
  }

  return (
    <motion.div
      className={styles.backdrop}
      onClick={onClose}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, delay: 0.1 }}
    >
      <aside className={styles.menu} onClick={e => e.stopPropagation()}>
        <nav className={styles.navWrapper}>
          <ul className={styles.nav}>
            {navItemCategories.map(({ id, label, Icon }) => (
              <li key={id}>
                <Link 
                  to={`/shop/${id}`} 
                  onClick={() => handleNavClick(id)} 
                  className={styles.link}
                >
                  <Icon className={styles.icon} />
                  <span>{label}</span>
                </Link>
              </li>
            ))}
            {navItems.map(({ id, label, Icon }) => (
              <li key={id} onClick={() => handleNavClick(id)}>
                <Icon className={styles.icon} />
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </nav>
        <div className={styles.contactsBlock}>
          <motion.div
            className={styles.row}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <span className={styles.label}>Співпраця/партнерство</span>
            <a href="mailto:contact@seaters.coffee" className={styles.email}>
              contact@seaters.coffee
            </a>
          </motion.div>
          <motion.div
            className={styles.row}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <span className={styles.label}>
              Підтримка <span>10:00–22:00</span>
            </span>
            <a
              href="https://t.me/seaters_coffee"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.telegram}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                <g clipPath="url(#clip0_24_88)">
                  <path
                    d="M8.0321 12.3794L7.72962 16.5565C8.16239 16.5565 8.34982 16.3739 8.57459 16.1548L10.6036 14.251L14.8079 17.2738C15.5789 17.6957 16.1222 17.4736 16.3302 16.5774L19.0899 3.88154L19.0906 3.88079C19.3352 2.76171 18.6784 2.32411 17.9272 2.59864L1.70585 8.69598C0.598777 9.11788 0.615539 9.7238 1.51766 9.99833L5.6648 11.2648L15.2978 5.34697C15.7511 5.05224 16.1633 5.21531 15.8243 5.51004L8.0321 12.3794Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_24_88">
                    <rect
                      width="18.2857"
                      height="18.2857"
                      fill="white"
                      transform="translate(0.856934 0.856934)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </motion.div>
        </div>
      </aside>
    </motion.div>
  )
}
